module.exports = __webpack_public_path__ + "img/blind_guide.198faa8c.png";